import Vue from 'vue';
import { Actions, Mutations, Pages } from '@/util/settings/enums';
import useMSALEventsHandler from '@/hooks/useMSALEventsHandler';
import { computed, onMounted } from '@vue/composition-api';
import useDoctorIdAndConnectId from '@/hooks/useDoctorIdAndConnectId';
import config from '@/config';
import Footer from '@/components/common/Footer.vue';
export default Vue.extend({
    name: 'GMCConnectV2',
    components: {
        Footer
    },
    setup(props, context) {
        const onSuccessCallback = () => {
            context.root.$store.commit(Mutations.SET_IS_AUTHENTICATED, true);
        };
        const onFailureCallback = () => {
            context.root.$store.commit(Mutations.SET_IS_AUTHENTICATED, false);
        };
        useMSALEventsHandler(onSuccessCallback, onFailureCallback);
        onMounted(() => {
            context.root.$store.dispatch(Actions.FETCH_CONTENT);
        });
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const [_, connectId] = useDoctorIdAndConnectId(context);
        const isAuthenticated = computed(() => context.root.$store.state.Auth.isAuthenticated);
        const isAuthDataSet = computed(() => context.root.$store.state.Auth.isAuthDataSet);
        const isContentFetched = computed(() => context.root.$store.state.Content.isFetched);
        const currentRoute = computed(() => context.root.$route.name);
        const isSignInPage = computed(() => currentRoute.value === config.app.signInPath);
        const shouldShowProtectedRoutes = computed(() => {
            let isPageLoaded = isAuthenticated.value && isAuthDataSet.value && isContentFetched.value;
            if (isPageLoaded && connectId.value) {
                switch (currentRoute.value) {
                    case Pages.PROFILE:
                        window.location.href = config.url.redirect.profileConnectIdClaimExistsRedirectUrl;
                        isPageLoaded = false;
                        break;
                    default:
                        break;
                }
            }
            return isPageLoaded;
        });
        const content = computed(() => context.root.$store.state.Content.content);
        return {
            shouldShowProtectedRoutes,
            isSignInPage,
            content
        };
    }
});
